import Quill from 'quill';
import { MentionBlot } from './blots/mention';
import { Mention } from 'quill-mention';

Quill.register({ 'blots/mention': MentionBlot, 'modules/mention': Mention });

export default Mention;
